// extracted by mini-css-extract-plugin
export default {"title":"AccountDetails_title__8Wx6Z","wrapper":"AccountDetails_wrapper__9FHEh","filled":"AccountDetails_filled__Ec7Dt","row":"AccountDetails_row__H7iGp"};